import React from 'react';
import ContentBox from '../../shared/content-box';
import "./content-box-panel.css";
import { t, getCurrentLanguage, getModalContent } from '../../../utils/translations';
import useLanguageStore from '../../../store/languageStore';

class ContentBoxPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLanguage: getCurrentLanguage()
        };
    }

    componentDidMount() {
        // Subscribe to language changes
        this.unsubscribe = useLanguageStore.subscribe((state) => {
            this.setState({ currentLanguage: state.currentLanguage });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        const { currentLanguage } = this.state;
        
        return (
            <div className="content-box-panel">
                <div className="content-box-panel-content">
                    <ContentBox text={t('framework', currentLanguage).toUpperCase()} modalContent={getModalContent('framework_modal', currentLanguage)} />
                    <ContentBox text={t('tecnologia', currentLanguage).toUpperCase()} modalContent={getModalContent('tecnologia_modal', currentLanguage)} />
                    <ContentBox text={t('cloud', currentLanguage).toUpperCase()} modalContent={getModalContent('cloud_modal', currentLanguage)} />
                </div>
            </div>
        );
    }
};

export default ContentBoxPanel;